import { COMMON_STYLE, DISPLAY_CLASSES, GRADIENT_CLASSES, TEXT_DECORATION_CLASSES, WHITESPACE_CLASSES, customTV, } from '../../../utils/tailwind';
import { TYPOGRAPHY_ALIGN } from './align';
import { TYPOGRAPHY_COMPONENTS } from './components';
import { TYPOGRAPHY_GRADIENTS } from './gradients';
import { TYPOGRAPHY_UNDERLINES_BASE, TYPOGRAPHY_UNDERLINES_THICKNESS, TYPOGRAPHY_UNDERLINE_VARIANTS, } from './underlines';
import { TYPOGRAPHY_VARIANTS } from './variants';
import { TYPOGRAPHY_WEIGHTS } from './weights';
export * from './align';
export * from './variants';
export * from './weights';
export * from './gradients';
export * from './underlines';
export * from './components';
export const typography = customTV({
    base: [...COMMON_STYLE, 'm-0', 'text-content-default', 'dark:text-content-default-dark'],
    variants: {
        display: DISPLAY_CLASSES,
        textDecoration: TEXT_DECORATION_CLASSES,
        whiteSpace: WHITESPACE_CLASSES,
        variant: TYPOGRAPHY_VARIANTS,
        weight: TYPOGRAPHY_WEIGHTS,
        align: TYPOGRAPHY_ALIGN,
        component: TYPOGRAPHY_COMPONENTS,
        gradient: {
            true: TYPOGRAPHY_GRADIENTS,
        },
        gradientVariant: GRADIENT_CLASSES,
        underlined: {
            true: TYPOGRAPHY_UNDERLINES_BASE,
        },
        underlineThickness: TYPOGRAPHY_UNDERLINES_THICKNESS,
        underlineVariant: TYPOGRAPHY_UNDERLINE_VARIANTS,
    },
    defaultVariants: {
        display: 'inherit',
        align: 'inherit',
    },
});
